<template>
    <div :class="ui.root()">
        <slot />
    </div>
</template>

<script setup lang="ts">
    import {
        GlassSurfaceBackgrounds,
        type GlassSurfaceBackground
    } from '@/assets/css/themes/custom-components/constants/glass-surface';

    const props = defineProps({
        background: {
            type: String as PropType<GlassSurfaceBackground>,
            default: GlassSurfaceBackgrounds.Primary
        }
    });

    const ui = useComponentUi('glassSurface', () => ({
        background: props.background
    }));
</script>
